import { render, staticRenderFns } from "./SGBackupSummary.vue?vue&type=template&id=43048746"
import script from "./SGBackupSummary.vue?vue&type=script&lang=js"
export * from "./SGBackupSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports